import { render, staticRenderFns } from "./AnnouncementBar.vue?vue&type=template&id=6d3202aa&scoped=true"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3202aa",
  null
  
)

export default component.exports